__turbopack_context__.v({
  "wrapper": "CtaBox-module__hdoTvq__wrapper",
});
